export default {
  props: {
    pdf: String,
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '1024px'
    }
  },
  data() {
    return {
      viewer: '/pdf/web/viewer.html?file=',
      pdfUrl: ''
    };
  },
  mounted() {
    this.pdfUrl = this.viewer + this.pdf;
  }
};